<template>
  <div>
    <div v-if="$store.state.screenWidth>900"
         class="footerNav flexCenter">
      <div class="footerNav-banner flexSpaceStart">
        <div>
          <div class="accc lineHeight40 fontW700 fontSize16">谷医堂中医馆 / 谷医堂大药房（总店）：</div>
          <div class="abfbfbf lineHeight20 fontSize15">Tel：400-8855-091</div>
          <div class="abfbfbf lineHeight20 fontSize15">Add：长沙市雨花区圭塘体院路39号京豪大厦1栋107号</div>
          <div class="accc lineHeight40 fontW700 fontSize16">集团总部：</div>
          <div class="abfbfbf lineHeight20 fontSize15">Add：湖南省长沙市望城区望雷大道179号金荣同心国际工业园C3、C6栋</div>
          <div class="abfbfbf lineHeight20 fontSize15">Tel：400-8855-091</div>
          <a class="abfbfbf lineHeight20 fontSize15"
             href="https://beian.miit.gov.cn">湘ICP备2020019989号-1</a>
        </div>
        <div>
          <div class="accc lineHeight40 fontW700 fontSize16">湖南省互联网医院 客服专线：</div>
          <div class="accc fontW700 footerNav-phone">400-8855-091</div>
               <div class="accc lineHeight40 fontW700 fontSize16">友情链接：</div>
               <a class="abfbfbf lineHeight20 fontSize15"
               href="http://113.247.223.7:7001/index">长沙网安数字警务室</a>
        </div>
        <div class="footerNav-wxCode fontSize16 abfbfbf textCenter">
          <img class="footerNav-wxCodeImg"
               src="https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/jusekeji-gw/hunan/H5yh.png"
               alt="">
          <div>扫一扫</div>
          <div>看病更轻松</div>
        </div>
      </div>
    </div>
    <div v-else
         class="footerNav">
      <div class="footerNav-header flexSpace">
        <div class="footerNav-header-ewm">
          <img src="https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/hospital-gw/hlwyygzh.jpg"
               alt="">
          <div>扫码关注</div>
          <div>看病更轻松</div>
        </div>
        <div class="footerNav-header-phone">
          <div class="font24 ae6e6e6">谷医堂互联网医院 &nbsp;&nbsp;&nbsp;&nbsp; 客服专线：</div>
          <div class="ae6e6e6 fontW700 footerNav-phone">400-8855-091</div>
        </div>
      </div>
      <div class="footerNav-footer textCenter">
        <div class="ae6e6e6 lineHeight60 fontW700 font22">谷医堂中医馆 / 谷医堂大药房（总店）：</div>
        <div class="abfbfbf lineHeight40 font21">Tel：400-8855-091</div>
        <div class="abfbfbf lineHeight40 font21">Add：长沙市雨花区圭塘体院路39号京豪大厦1栋107号</div>
        <div class="ae6e6e6 lineHeight60 fontW700 font22">集团总部：</div>
        <div class="abfbfbf lineHeight40 font21">Add：湖南省长沙市望城区望雷大道179号金荣同心国际工业园C3、C6栋</div>
        <div class="abfbfbf lineHeight40 font21">Tel：400-8855-091</div>
        <a class="abfbfbf lineHeight40 font21"
           href="https://beian.miit.gov.cn">湘ICP备2020019989号-1</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
@import url("../../../static/css/fontSize.less");
.footerNav {
  width: 100%;
  background: #404040;
}
@media screen and (max-width: 900px) {
  .lineHeight60 {
    line-height: 60 * @width;
  }
  .lineHeight40 {
    line-height: 40 * @width;
  }
  .footerNav {
    padding: 0 60 * @width;
    .footerNav-header {
      height: 300 * @width;
      border-bottom: 2 * @width solid #666;
      .footerNav-header-ewm {
        font-size: 22 * @width;
        line-height: 35 * @width;
        color: #bfbfbf;
        text-align: center;
        img {
          width: 126 * @width;
          height: 126 * @width;
        }
      }
      .footerNav-header-phone {
        .footerNav-phone {
          font-size: 40 * @width;
          line-height: 47 * @width;
          margin-top: 25 * @width;
        }
      }
    }
    .footerNav-footer {
      padding-bottom: 40 * @width;
    }
  }
}
@media screen and (min-width: 900px) {
  .lineHeight40 {
    line-height: 40px;
  }
  .lineHeight20 {
    line-height: 20px;
  }
  .fontSize16 {
    font-size: 16px;
  }
  .fontSize15 {
    font-size: 15px;
  }
  .footerNav {
    height: 230px;
    .footerNav-banner {
      min-width: 1200px;
      .footerNav-phone {
        font-size: 24px;
        line-height: 40px;
      }
      .footerNav-wxCode {
        .footerNav-wxCodeImg {
          width: 105px;
          height: 105px;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footerNav/footerNav.vue